import React from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Styles from "./Footer.module.css";
import Logo from "../assets/Logo/IraqWonders.svg";
import fbIcon from "../assets/Icons/Facebook.svg";
import twitterIcon from "../assets/Icons/Twitter.svg";
import instagramIcon from "../assets/Icons/Instagram.svg";
import userIcon from "../assets/Icons/user.svg";
import background from "../assets/Images/footer.png";
import { useTranslation } from "react-i18next";

function Footer() {
	const { t, i18n } = useTranslation();
	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";


	const validationSchema = Yup.object({
		email: Yup.string()
			.email("Invalid email address")
			.required("Required"),
	});

	const formik = useFormik({
		initialValues: {
			email: "",
		},
		validationSchema,
		onSubmit: (values) => {
			// Handle submission here
			alert(values.email);
		},
	});

	return (
		<div className={Styles.footerContainer}>
			<div className={Styles.row}>
				<img
					className={Styles.logo}
					src={Logo}
					alt='IraqWonders Logo'
				/>

				<div className={Styles.newsletter}>
					<div className={Styles.flex}>
						<img
							className={Styles.userIcon}
							src={userIcon}
							alt='user icon'
						/>
						<input
							className={Styles.inputIcon}
							type='email'
							id='email'
							name='email'
							placeholder='Newsletter'
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							value={formik.values.email}
						/>
					</div>

					<button
						type='submit'
						className={Styles.btn}
						onClick={() => {
							if (
								formik.errors.email &&
								formik.touched.email
							) {
								alert(formik.errors.email);
							} else {
								formik.handleSubmit();
							}
						}}
					>
						{t("footer.title")}
					</button>
				</div>

				<div className={Styles.iconsContainer}>
					<a
						href='https://www.facebook.com/'
						target='_blank'
						rel='noreferrer'
					>
						<img
							className={Styles.icon}
							src={fbIcon}
							alt='Facebook Icon'
						/>
					</a>

					<a
						href='https://twitter.com/?lang=en'
						target='_blank'
						rel='noreferrer'
					>
						<img
							className={Styles.icon}
							src={twitterIcon}
							alt='Twitter Icon'
						/>
					</a>

					<a
						href='https://www.instagram.com/'
						target='_blank'
						rel='noreferrer'
					>
						<img
							className={Styles.icon}
							src={instagramIcon}
							alt='Instagram Icon'
						/>
					</a>
				</div>
			</div>
			<hr className={Styles.line} />

			<div
				className={Styles.row}
				dir={isRtl ? "rtl" : "ltr"}
			>
				<ul className={Styles.navbarLinks}>
					<li>
						<Link
							to='/'
							className={Styles.link}
						>
							{t("Navbar.Home")}
						</Link>
					</li>
					<li>|</li>
					<li>
						<Link
							to='BookYourGuide'
							className={Styles.link}
						>
							{t("Navbar.Book your Guide")}
						</Link>
					</li>
					<li>|</li>

					<li>
						<Link
							to='ExploreIraq'
							className={Styles.link}
						>
							{t("Navbar.Explore Iraq")}
						</Link>
					</li>
					<li>|</li>

					<li>
						<Link
							to='AboutUs'
							className={Styles.link}
						>
							{t("Navbar.About Us")}
						</Link>
					</li>
					<li>|</li>

					<li>
						<Link
							to='ContactUs'
							className={Styles.link}
						>
							{t("Navbar.Contact Us")}
						</Link>
					</li>
				</ul>
			</div>
			<div className={Styles.copyright}>
				{t("footer.Copyright")}
			</div>

			<img
				className={Styles.backgroundFooter}
				src={background}
				alt='Footer'
			/>
		</div>
	);
}

export default Footer;
